module.exports = __webpack_public_path__ + "media/images/Import-324a95c253eecff2b595abd2e53f2fb6.svg";